import {
  Component,
  computed,
  inject,
  input,
  numberAttribute,
} from '@angular/core';
import { LangService } from '../../services/lang/lang.service';

@Component({
  selector: 'app-total',
  imports: [],
  templateUrl: './total.component.html',
  styleUrl: './total.component.scss',
})
export class TotalComponent {
  private langService = inject(LangService);
  private labels = this.langService.lang.shared.total;

  value = input(0, { transform: value => numberAttribute(value, 0) });

  text = computed(() => this.labels.totalText(this.value()));
}
